module.exports = __webpack_public_path__ + "static/media/flag-earth.e1fe7eb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/other/flag-earth.svg
// module id = 34
// module chunks = 0